module.exports = __webpack_public_path__ + "img/java.6615eab6.png";